module.exports = __webpack_public_path__ + "img/202304-xl.f58ba64b.png";